import { timecodeFrameToSeconds } from 'weave-timeline';
import { formatFrames, parseFrames } from '@/utils/mediaPlaying';
import { clampValue } from '@/utils/numbers';
import { EditableInput } from './EditableInput';

const FRAME_INPUT_WIDTH = 74;

interface FrameInputProps {
  currentTime: number;
  duration: number;
  fps: number;
  paused: boolean;
  onTogglePlay: () => void;
  onSetTime: (time: number, ongoing: boolean) => void;
}

export function FrameInput({ currentTime, duration, fps, paused, onTogglePlay, onSetTime }: FrameInputProps) {
  const syncedValue = formatFrames(currentTime, fps);

  const commit = (value: string): string | null => {
    const frame = parseFrames(value);
    if (frame === null) return null;
    const nextTime = clampValue(timecodeFrameToSeconds(frame, fps), 0, duration);
    onSetTime(nextTime, false);
    return formatFrames(nextTime, fps);
  };

  return (
    <EditableInput
      ariaLabel="Playback frame"
      syncedValue={syncedValue}
      width={FRAME_INPUT_WIDTH}
      paused={paused}
      onTogglePlay={onTogglePlay}
      onCommit={commit}
    />
  );
}
